import { defaultApiState } from '../api.state';

export const advisorSettlementState = {
  apiState: {
    getAdvisorSettlements: defaultApiState,
    getAdvisorSettlement: defaultApiState,
    updateAdvisorSettlement: defaultApiState,
  },
  advisorSettlements: [],
  advisorSettlement: undefined,
};
